// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ubx8","cell":"ColumnAccessor_cell__q2rlx","firstCellAccent":"ColumnAccessor_firstCellAccent__1TONN"};